// extracted by mini-css-extract-plugin
export default {"bullets":"IzB3Tvfk","bullet":"nlIrWAub"};